import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ChangePlanSummaryComponent} from "./change-plan-summary/change-plan-summary.component";
import {ChangePlanSummaryV2Component} from "./change-plan-summary-v2/change-plan-summary-v2.component";
import {properties} from 'src/environments/properties';

const getChangePlanComponent = () => {
  const isV2Enabled = properties?.featureFlags?.enableForUPlus;
  return isV2Enabled ? ChangePlanSummaryV2Component : ChangePlanSummaryComponent;
};


const routes: Routes = [
    {
        path: '',
        component: getChangePlanComponent(),
    },
    {
        path: 'change',
        component: getChangePlanComponent(),
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ChangePlanRoutingModule {
}
